import { join } from 'lodash-es';
import moment from 'moment';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import OrderStatusColors from '../../components/orderStatusColors';
import OrderStatusShow from '../../components/orderStatusShow';
import tlp from './scheduledDeliveryDate.vue';
@Component({
    name: 'DefaultSelect',
    mixins: [tlp],
    components: {
        OrderStatusColors,
        OrderStatusShow,
    },
})
export default class ScheduledDeliveryDate extends Vue {
    @Prop({
        default: {},
    })
    propTrackedShipment: any;

    @Prop({
        default: '',
    })
    from: any;

    @Prop({
        default: '',
    })
    title: any;

    @Prop({
        default: false,
    })
    setUrl: boolean;

    @Prop({
        default: true,
    })
    isdisplayAddress: boolean;

    @Prop({
        default: 0,
    })
    sendContactSupportNumber: any;

    trackedShipment: any = {};
    deliveryStagesLine: any = 0;
    deliveryStages: any = 0;
    deliveryStagesheight: any = 5;
    prSsendContactSupportNumber = 0;

    @Watch('sendContactSupportNumber', { deep: true })
    getsendContactSupportNumber(val: any, oldVal: any) {
        this.prSsendContactSupportNumber = this.sendContactSupportNumber;
    }

    @Watch('propTrackedShipment', { deep: true })
    getpropTrackedShipment(val: any, oldVal: any) {
        this.trackedShipment = this.propTrackedShipment;
        this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
    }

    mounted() {
        this.trackedShipment = this.propTrackedShipment;
        this.prSsendContactSupportNumber = this.sendContactSupportNumber;
        this.getProgressImage(this.trackedShipment.stage, this.trackedShipment.status);
    }

    private getProgressImage(shipmentStage: any, shipmentStatus: any) {
        if (shipmentStatus == 4 && shipmentStage == 5) {
            // Invoiced
            this.trackedShipment.filterStage = 'Delivered';
            this.deliveryStages = 5;
            this.deliveryStagesLine = 100;
            this.deliveryStagesheight = '192px';
        } else if (shipmentStage == 5 && shipmentStatus > 0) {
            // Delivered
            this.trackedShipment.filterStage = 'Delivered';
            this.deliveryStages = 4;
            this.deliveryStagesLine = 100;
            this.deliveryStagesheight = '192px';
        } else if (shipmentStage == 4 && shipmentStatus > 0) {
            // Out for Delivery
            this.trackedShipment.filterStage = 'Out for Delivery';
            this.deliveryStages = 3;
            this.deliveryStagesLine = 75;
            this.deliveryStagesheight = '128px';
        } else if (shipmentStage == 1 || shipmentStage == 2 || shipmentStage == 3) {
            // Picked Up
            this.trackedShipment.filterStage = 'Picked Up';
            this.deliveryStages = 2;
            this.deliveryStagesLine = 50;
            this.deliveryStagesheight = '64px';
        } else if (shipmentStage == 0 && shipmentStatus > 1) {
            // In Process
            this.trackedShipment.filterStage = 'In-Process';
            this.deliveryStages = 1;
            this.deliveryStagesLine = 5;
            this.deliveryStagesheight = '8px';
        } else if (shipmentStage == 0 && shipmentStatus == 1) {
            // Order created
            this.trackedShipment.filterStage = 'Schedule pick up';
            this.deliveryStages = 1;
            this.deliveryStagesLine = 5;
            this.deliveryStagesheight = '8px';
        } else {
            // Empty
            this.deliveryStages = 1;
            this.deliveryStagesLine = 5;
            this.deliveryStagesheight = '8px';
        }

        this.$forceUpdate();
    }

    trackedShipmentDetail(orderId: any) {
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: orderId,
                from: '6',
            },
        });
        // this.$router.push(from.path)
        /*  let routeData = this.$router.resolve({
            name: 'ShipmentView',
            params: {
                orderId: orderId,
                from: '1',
            }
        });
         window.open(routeData.href, '_blank');*/
    }

    fiterDate(dateTime: any) {
        if (dateTime) {
            let time = moment(dateTime).format('dddd, MMMM D YYYY');
            return time;
        }
    }

    fiterTime(dateTime: any) {
      if (dateTime) {
        let time = moment(dateTime).format('HH:mm');
        return time;
      }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/scheduled-delivery-date/index.ts